import Tabs from '@10up/component-tabs';

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.tabs');

	const checkHashLoad = ( block ) => {
		const hash = window.location.hash.replace('#', '');
		if( hash.length ) {
			const buttons = block.querySelectorAll(`[aria-controls='${hash}']`); // TODO: check this with nested items.
			buttons.forEach((button) => {
				button.click();
				const panel = document.getElementById(hash);
				if (!panel) return;
				const headerOffset = document.querySelector('header.header')?.offsetHeight || 0;
				const y = panel.getBoundingClientRect().top + window.pageYOffset - headerOffset - 8;
				window.scrollTo({ top: y, behavior: 'instant' });
			});
		}
	}

	const setupHashClickEvents = ( block ) => {
		const panelButtons = block.querySelectorAll(`.tab-item [aria-controls]`); // TODO: check this with nested items.
		panelButtons.forEach((button) => {
			const panelId = button.getAttribute('aria-controls');
			const links = document.querySelectorAll(`a[href='#${panelId}']`);
			links.forEach((link) => {
				link.addEventListener("click", function ( event ) {
					button.click();
				});
			});
		});
	}

	blocks.forEach((block) => {
		new Tabs( `#${block.id}`, {
			orientation: block.dataset.orientation,
			onCreate: function() {
				const detail = {};
				block.dispatchEvent(new CustomEvent('tribe.tabs.create', { detail } ));
				checkHashLoad(block);
				setupHashClickEvents( block );

			},
			onTabChange: function() {
				const detail = {};
				block.dispatchEvent(new CustomEvent('tribe-tabs-change', { detail } ));
			}
		} );
	});

});
